import React from 'react';

import StyledDivider from './Styles';

const Divider = () => <StyledDivider/>

export default Divider